import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
//import ThemeContext from "../../context/ThemeContext";
import ThemeContext from "../../../../../context/ThemeContext";
import UserContext from "../../../../../context/UserContext";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { RadioButton } from "primereact/radiobutton";
import { Calendar } from 'primereact/calendar';
import { InputNumber } from 'primereact/inputnumber';

import {IntlProvider, FormattedMessage, FormattedNumber, useIntl} from 'react-intl'
import messages from '../../../../../lang/LangGlb';
import { InputText } from "primereact/inputtext";

const GET_POST = gql`
  query MyQuery12($firmSubCode: String!,$rTypeCode: String!, $roomFactorId: Int, $perType: String, $firmMainCode: String!, $person: Int) {
    tbl_htl_room_type_factor(
      where: {
        firm_main_code: { _eq: $firmMainCode},
        firm_sub_code: { _eq: $firmSubCode },
         factor_id: { _eq: $roomFactorId },
         r_type_code: { _eq: $rTypeCode },
         per_type: { _eq: $perType },
         person: { _eq: $person },

      }
    ) {
        factor_id
        firm_main_code
        firm_sub_code
        r_type_code       
        per_type       
        per_factor
        factor_type
        person
     
    }
  }
`;




const UPDATE_FIRM = gql`
mutation UpdateRoomClass(
  $firmMainCode: String!
  $firmSubCode: String!
  $rTypeCode: String!
  $perType: String! 
  $person: Int,
  $perFactor: float8,
  $roomFactorId: Int
  

) {
    update_tbl_htl_room_type_factor(
    where: {
        firm_main_code: { _eq: $firmMainCode },
        firm_sub_code: { _eq: $firmSubCode },
        r_type_code: { _eq: $rTypeCode },
        factor_id: { _eq: $roomFactorId }
       
        

    },
    _set: {
    
        per_factor: $perFactor,
        person: $person,
        per_type: $perType,
      
        
    


       }
  ) {
    affected_rows
  }
}
`;

const INSERT_PER = gql`
  mutation InsertPeriod(
    $firmMainCode: String!
    $firmSubCode: String!
    $rTypeCode: String
    $perType: String 
    $person: Int
    $perFactor: float8
    $roomFactorId: Int
   
   
    
  ) {
    insert_tbl_htl_room_type_factor(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        r_type_code: $rTypeCode,
        per_type: $perType,
        person: $person,
        per_factor: $perFactor,
        factor_id: $roomFactorId
        
        

        
      }
    ) {
      affected_rows
    }
  }
`;

const UPDATE_ID_SEQ2 = gql`
mutation UpdateIdSeq2($type: String!) {
  update_tbl_id_SEQ(
    where: { type: { _eq: $type } }
    _inc: { id_seq: 1 }
  ) {
    returning {
      id_seq
    }
  }
}
`;

const INSERT_RCLASS = gql`
  mutation InsertRoomClass(
    
    $rClassName: String!
    $rClassCode: String!
    $ownFirmCode: String!
    $ownFirmSubCode: String!
    $active: Boolean!
    
    
  ) {
    insert_tbl_htl_room_class(
      objects: {
       
        firm_main_code: $ownFirmCode,
        firm_sub_code: $ownFirmSubCode,
        r_class_code: $rClassCode,
        r_class_name: $rClassName,
        active: $active,
        
        
      }
    ) {
      affected_rows
    }
  }
`;


const GET_PERSON_TYPE = gql`
  query MyQuery($drbtype: String!, $lang: String!) {
    tbl_gnl_def(
      where: {
        type: { _eq: $drbtype },
        lang: { _eq: $lang }
      }
    ) {
      code
      name
      type
      lang
    }
  }
`;









const HtlRoomFactorDtl = () => {


  const { theme, setTheme } = useContext(ThemeContext);
  const { varCode, setVarCode } = useContext(ThemeContext);
  const { varCode2, setVarCode2 } = useContext(ThemeContext);
  const { varCode3, setVarCode3 } = useContext(ThemeContext);
  const { varCode4, setVarCode4 } = useContext(ThemeContext);


  const { users } = useContext(UserContext);

  const firmMainCode = users.firmcode;
  const firmSubCode = users.subfirmcode;

  const intl = useIntl();
  const currentLocale = users.userLang || localStorage.getItem('lang') || 'en';
  
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { firmSubCode: firmSubCode, firmMainCode: firmMainCode, rTypeCode: varCode , perType: varCode2 ,person: varCode3, roomFactorId: varCode4},
  });
  const [UpdateRoomClass] = useMutation(UPDATE_FIRM);
  const [InsertPeriod] = useMutation(INSERT_PER);
  const [updateIdSeq2] = useMutation(UPDATE_ID_SEQ2); 

  const firmData = data && data.tbl_htl_room_type_factor ? data.tbl_htl_room_type_factor[0] : null;

 
  const { loading: drbLoading, error: drbError, data: drbData } = useQuery(GET_PERSON_TYPE, {
    variables: { drbtype: "PTYP", lang: currentLocale },
  });


 
  const [perId, setPerId] = useState(firmData ? firmData.active : 0);
  const [rTypeCode, setRTypeCode] = useState(firmData ? firmData.r_type_code : varCode);
  const [perType, setPerType] = useState(firmData ? firmData.per_type : "");
  const [person, setPerson] = useState(firmData ? firmData.person : null);
  const [perFactor, setPerFactor] = useState(firmData ? firmData.per_factor : "");
  const [seaId, setSeaId] = useState(firmData ? firmData.sea_id_seq : "");
  const [startDate, setStartDate] = useState(firmData ? new Date(firmData.start_date): new Date());
  const [endDate, setEndDate] = useState(firmData ? new Date(firmData.end_date) : new Date());
  const [perCode, setPerCode] = useState(firmData ? firmData.period : "");
  const [releaseDay, setReleaseDay] = useState(firmData ? firmData.release : "");
  const [minStayDay, setMinStayDay] = useState(firmData ? firmData.min_stay : "");
  const [perPricePercent, setPerPricePercent] = useState(firmData ? firmData.per_price_percent : "");
  const [roomFactorId, setRoomFactorId] = useState(firmData ? firmData.factor_id : "");
 




  
  
  
  console.log("Firm Data:", firmData);

  const ownFirmCode = users.firmcode;
  const ownFirmSubCode = users.subfirmcode;
  


  

  
  const updaterec = messages[currentLocale].updaterec;
  
  const room_type_code = messages[currentLocale].room_type_code;
  
  const rule_person_title = messages[currentLocale].rule_person_title
  
  const factor_title = messages[currentLocale].factor_title;
  const new_factor_btn = messages[currentLocale].new_factor_btn;
  

  const start_date_title = messages[currentLocale].start_date_title;
  const end_date_title = messages[currentLocale].end_date_title;
  const sea_new_per_btn = messages[currentLocale].sea_new_per_btn;
  const sea_id_title = messages[currentLocale].sea_id_title;
  const per_id_title = messages[currentLocale].per_id_title;
  const per_code_title = messages[currentLocale].per_code_title;
  const per_relaise_title = messages[currentLocale].per_relaise_title;
  const per_min_stay_title = messages[currentLocale].per_min_stay_title;

 
  

  useEffect(() => {
    if (perId !== 0) {    
      
      handleinsert();  
    
    }
  }, [perId, setPerId]);
  
  useEffect(() => {
    if (firmData) {
      
   
      setPerType(firmData.per_type);
      setRTypeCode(varCode);
      setPerson(firmData.person);
      setPerFactor(firmData.per_factor);     
      setPerCode(firmData.dyn_grp_code);
      setRoomFactorId(firmData.factor_id);
    
   
      
      
    }
  }, [firmData]);

 

  const handleUpdate = () => {
    const adjustedPerFactor = (perFactor === 0 || perFactor === null) ? 0.001 : perFactor;
    UpdateRoomClass({
      variables: {
        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perType: perType,
        rTypeCode: rTypeCode,      
        person: person,
        perFactor: adjustedPerFactor,
        roomFactorId: roomFactorId
       
      

        
      },
    })
      .then(() => {
        window.alert("Factor updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating Factor:", error);
        
        error.graphQLErrors.forEach(err => console.error('GraphQL Error:', err));
      });
  };

  const handleinsert = () => {
    InsertPeriod({
      variables: {

        firmMainCode: firmMainCode,
        firmSubCode: firmSubCode,
        perType: perType,
        rTypeCode: rTypeCode,      
        person: person,
        perFactor: perFactor,
        roomFactorId: roomFactorId,

       
    
           
      },
    })
      .then(() => {
        window.alert("Room Factor insert successfully!");
        refetch();
      })
      .catch((error) => {
        console.error("Error insert Factor:", error);
      });
  };

  const handleUpdateIdSeq = async () => {
    try {
      const { data } = await updateIdSeq2({
        variables: {
          type: 'RPFAC', 
        },
      });
      const updatedIdSeq = data.update_tbl_id_SEQ.returning[0].id_seq;
      console.log(`ID_SEQ güncellendi: ${updatedIdSeq}`);
      setRoomFactorId(updatedIdSeq);  
      setPerId(updatedIdSeq);
  //    setVarCode2(updatedIdSeq.toString());  
   //   console.log(perId);
    //  setSeaId(varCode);
     
       
      
    } catch (error) {
      console.error('Güncelleme hatası:', error);
    }
  };


  const personSelectItemsB = drbData && drbData.tbl_gnl_def
  ? drbData.tbl_gnl_def.map(item => ({
      label: item.name,
      value: item.code,
      name: item.name, 
    }))
  : [];

  if (loading) return <p>Loading...</p>;
if (error) return <p>Error: {error.message}</p>;




return (
  <div className="container mt-0 p-2 mx-auto  dark:text-gray-100">
    

    
    <div className="flex">
   <div className="mr-2 w-1/3" >
    
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {room_type_code}
    </label>
    <InputText    
      id="periodCode"   
      value={rTypeCode}
      onChange={(e) => setRTypeCode(e.target.value)}
      readOnly

      
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
  </div>

  <div className="mr-2 w-1/3" >
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {"id'"}
    </label>
    <InputNumber 
      inputId="integeronly"
      useGrouping={false} 
      value={roomFactorId}
      onValueChange={(e) => setRoomFactorId(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
  </div>
  </div> 
    
    
    <div className="flex mt-2">

    <div className="w-1/3 ml-3 h-10 gap-3">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {rule_person_title}
    </label>
    <InputText    
      id="periodCode"   
      value={person}
      onChange={(e) => setPerson(e.target.value)}

      
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
  </div>
  
  

  <div className="w-1/3 ml-3 h-10 gap-3">
  <label htmlFor="firmType" className="block font-medium text-gray-700">
      {rule_person_title}
    </label>
    <InputText    
      id="periodCode"   
      value={perType}
      onChange={(e) => setPerType(e.target.value)}

      
      className="w-full h-11  border-gray-300 rounded-md "
      
   />
   
  </div>

  <div className="w-1/8 pl-2">
    <label htmlFor="roomClassDropdown" className="block font-medium text-gray-700">
      {"Person Type"}
    </label>
    <Dropdown
      className="w-full h-11 rounded-md focus:ring-violet-800 focus:border-violet-800 block  border-gray-400"
      value={perType}
      options={personSelectItemsB}
      onChange={(e) => setPerType(e.value)}
      placeholder={"select_a_Person_type"}
    />
  </div>         

   <div className="w-1/3 ml-3 h-10 gap-3">
    <label htmlFor="firmType" className="block font-medium text-gray-700">
      {factor_title}
    </label>
    <InputNumber     
      inputId="integeronly"  
      useGrouping={false}     
      value={perFactor}
      
      onValueChange={(e) => setPerFactor(e.value)}
      className="w-full h-11  border-gray-300 rounded-md "
      maxFractionDigits={3}
      
   />
  
  </div> 
  
  </div>



     

   

       

    

    <div className="mt-4 flex justify-end">
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdate}
      >
        {updaterec}
      </button>
      <button
        className="bg-violet-900 mr-4 hover:bg-violet-300 text-white font-semibold px-4 py-2 rounded-md"
        onClick={handleUpdateIdSeq}
      >
        {new_factor_btn}
      </button>
    </div>
  </div>
);
};

export default HtlRoomFactorDtl;
